import { render, staticRenderFns } from "./StudioImage.vue?vue&type=template&id=d142f696&scoped=true&"
import script from "./StudioImage.vue?vue&type=script&lang=js&"
export * from "./StudioImage.vue?vue&type=script&lang=js&"
import style0 from "./StudioImage.vue?vue&type=style&index=0&id=d142f696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d142f696",
  null
  
)

export default component.exports